export default __webpack_public_path__ + "static/media/sca.92f7e6c8.svg";